import { AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';


export const passwordRepeatValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const passwordInput = control.get('password');
  const repeatPasswordInput = control.get('passwordRepeat');

  if (!passwordInput || !repeatPasswordInput) {
    return null;
  }

  if (passwordInput.disabled && repeatPasswordInput.disabled) {
    return null;
  }

  repeatPasswordInput.updateValueAndValidity({ onlySelf: true });

  if (
    passwordInput.value !== '' &&
    passwordInput.value === repeatPasswordInput.value) {
    return null;
  }

  const validationErrors = { repeatPasswordInputFeedback: 'SHARED.FORM-INPUTS.CUSTOMER-PASSWORD-INPUT.ERROR-REPEAT' };
  repeatPasswordInput.setErrors(validationErrors);
  return validationErrors;
};
